<!--
 * @Author: linrui
 * @Date: 2021-12-23 18:17:34
 * @LastEditors: linrui
 * @LastEditTime: 2022-01-08 15:48:51
 * @FilePath: /wechat-frontend/zmtx/src/views/doctor/examVideo.vue
-->
<template>
    <div class="exam-video" >
        <div
            class="uc-hd-bg"
            :style="'background-image: url('+ kv +'); height:0; padding-top: 50%;'"
            v-show="!isLandScape"
        >
        </div>
        <!-- <video id="homeVideo" class="home-video" width="100%" autoplay loop muted>
            <source :src="videoSrc" type="video/mp4">
        </video> -->
        <div class="video-wrapper">
            <div class="video-box">
                <video :src="videoSrc" controls="controls" width="100%" :height="isLandScape?landScapeWidth:'208px'" loop :poster="videoPoster" :autoplay="isLandScape">
                    您的浏览器不支持 video 标签。
                </video>
            </div>
        </div>
        <div class="exam-video-text" v-show="!isLandScape">
            <!-- <p class="title">视频简介</p> -->
            <!-- <p class="desc">{{ videoSummary }}</p> -->
        </div>
        <div class="page-ft btn" v-if="!isLandScape">
            <van-row>
                <van-col span="8">
                    <van-button class="back" @click="goBack">返回</van-button>
                </van-col>
                <van-col span="16">
                    <van-button class="up" @click="goToExam">开始答题</van-button>
                </van-col>
            </van-row>
        </div>
    </div>
</template>

<script>
import kv from '@/assets/kv.png'
import {GetExamVideos} from '../../api/api'
export default {
    data() {
        return {
            kv,
            videoSrc:'',
            // videoSummary:'',
            videoPoster:'',
            isLandScape:false, //是否是横屏
            landScapeWidth:''//横屏是视频宽度
        }
    },
    
    created() {
        this.landScapeWidth = `${document.documentElement.clientWidth - 46}px` || `${document.body.clientWidth - 46}px`
        let that = this
        window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", function() {
            if (window.orientation === 180 || window.orientation === 0) {    
                that.isLandScape = false
                console.log(that.isLandScape,'是否横屏')
            }       
            if (window.orientation === 90 || window.orientation === -90 ){  
                that.isLandScape = true
                console.log(that.isLandScape,'是否横屏')
            }     
        }, false)  

        GetExamVideos({
            params:{
                VideoSearch:{
                    config_id:64,
                    name:'考试视频'
                }
            }
        }).then( res => {
            console.log(res,'视频数据')
            this.videoSrc = `${this.baseUrl}${res.data.items[0].filepath}`
            // this.videoSummary = res.data.items[0].summary
            this.videoPoster = `${this.baseUrl}${res.data.items[0].image}`
        }).catch( err => {
            this.$toast(err.response.data.message)
        })
    },

    // mounted() {
    //     this.landScapeWidth = `${this.$refs.videoBox.offsetHeight}px`
    //     console.log(this.landScapeWidth,'this.landScapeWidth宽度');
    //     console.log(this.$refs,'ref');
    // },


    methods: {
        goBack() {
            this.$router.replace({
                name:'ExamIndex'
            })
        },

        goToExam() {
            this.$router.replace({
                name:'SingleChoiceExam'
            })
        }
    }
}
</script>

<style lang="less" scoped>
.uc-hd-bg {
    width: 100%; 
    background: top center no-repeat; 
    background-size: cover;
}
// .video-wrapper {
//     width: 100%;
//     .video-box {
//         width: 100vw;
//         height: 0;
//         position: relative;
//         padding-bottom: 56.25%;
//     }
// }
.exam-video-text {
    padding: 16px 16px 62px 16px;
    .title {
        margin-bottom: 7px;
        color: #000;
        text-align: left;
        font-size: 13px;
    }
    .desc {
        text-align: left;
        // text-indent: 20px;
        color:rgba(0, 0, 0, 0.6);
        font-size: 14px;
        line-height: 22px;
    }
}
.btn {
    padding-top: 7px;
    background-color: #fff;
    .back {
        border-color: @exam-theme-color;
        color: @exam-theme-color;
    }
    .up {
        background-color: @exam-theme-color;
    }
}
</style>